const url = process.env.REACT_APP_API_URL + "/api/projects";
export default {
  list: (projectId) => `${url}/${projectId}/get_project_kpi/`,
};
